import { type SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { PanelLeft } from "lucide-react";
import type { ComponentProps } from "react";

import { Button } from "./ui/button";

export function SidebarToggle({
    className,
}: ComponentProps<typeof SidebarTrigger>) {
    const { toggleSidebar } = useSidebar();

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    onClick={toggleSidebar}
                    variant="outline"
                    className="bg-white dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-800/50 hover:bg-blue-50 dark:hover:bg-blue-800/40"
                >
                    <PanelLeft size={16} />
                </Button>
            </TooltipTrigger>
            <TooltipContent align="start">Toggle Sidebar</TooltipContent>
        </Tooltip>
    );
}
